import MyListsSort from 'components/RichProfile/MyLists/MyListsSort/MyListsSort';

export default MyListsSort;
